<template>
  <!-- Desktop Table -->
  <div class="hidden md:block overflow-x-auto">
    <table class="w-full text-sm divide-base-200">
      <tbody>
        <tr v-for="plan in plans" :key="plan.id" :class="plan.id === popularId ? 'bg-primary/10' : ''">
          <td class="py-3 font-semibold whitespace-nowrap">
            <div class="flex items-center">
              {{ $t(plan.displayName) }}
              <span v-if="plan.id === popularId" class="badge badge-accent ml-2 text-xs">
                {{ $t("pricing.mostPopular") }}
              </span>
            </div>
          </td>

          <td class="py-3">
            <div class="flex flex-wrap gap-1 max-w-xs">
              <span
                v-for="feat in plan.features"
                :key="feat"
                class="rounded border border-base-content/20 px-2 py-1 text-xs break-words">
                {{ $t(feat) }}
              </span>
            </div>
          </td>

          <td class="py-3 text-right font-mono whitespace-nowrap">
            {{ format(plan.price).formatted }}
            <span class="badge badge-xs badge-outline capitalize">
              {{ $t("billing." + plan.billingLabel) }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Mobile Cards -->
  <div class="md:hidden space-y-3">
    <div 
      v-for="plan in plans" 
      :key="plan.id" 
      :class="plan.id === popularId ? 'bg-primary/10 border-primary/30' : 'bg-base-50'"
      class="p-4 rounded-lg border border-base-200">
      
      <div class="flex items-center justify-between mb-3">
        <div class="flex items-center">
          <h3 class="font-semibold text-base">{{ $t(plan.displayName) }}</h3>
          <span v-if="plan.id === popularId" class="badge badge-accent ml-2 text-xs">
            {{ $t("pricing.mostPopular") }}
          </span>
        </div>
        <div class="text-right">
          <div class="font-mono font-semibold">{{ format(plan.price).formatted }}</div>
          <span class="badge badge-xs badge-outline capitalize">
            {{ $t("billing." + plan.billingLabel) }}
          </span>
        </div>
      </div>

      <div class="flex flex-wrap gap-1">
        <span
          v-for="feat in plan.features"
          :key="feat"
          class="rounded border border-base-content/20 px-2 py-1 text-xs">
          {{ $t(feat) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from "vue";
import { createCurrencyFormatter } from "@/utils/formatCurrency";
import type { PlanOption } from "@/features/planSelection/models/PlanOption";

defineProps<{ plans: PlanOption[]; popularId?: string }>();
const format = createCurrencyFormatter({ locale: "nl-NL", currency: "EUR" });
</script>
